import { gql } from '@apollo/client'

export default gql`
  fragment CourseHomeworkPreview on CourseHomework {
    id
    title
  }
`
